import { useEffect, useState } from 'react';

export const useIsBrowser = () => {
  const [isBrowser, setIsWindow] = useState(false);

  useEffect(() => {
    /* istanbul ignore next */
    if (typeof window !== 'undefined') {
      setIsWindow(true);
    }
  }, []);

  return isBrowser;
};
